import { useCallback } from 'react';
import { useEventListener } from './useEventListener';

export const useHotKeyListener = (
  keyValue: string,
  onTrigger: () => void,
  needMeta?: boolean,
  needShift?: boolean,
  needCtrl?: boolean,
  disabled?: boolean,
) => {
  if (!needMeta && !needShift && !needCtrl) {
    throw new Error('At least one modifier key must be set');
  }

  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (disabled) return;
      if (onTrigger == null || e.key !== keyValue) return;
      if (needMeta && !e.metaKey) return;
      if (!needMeta && e.metaKey) return;
      if (needShift && !e.shiftKey) return;
      if (!needShift && e.shiftKey) return;
      if (needCtrl && !e.ctrlKey) return;
      if (!needCtrl && e.ctrlKey) return;
      e.preventDefault();
      e.stopPropagation();

      onTrigger?.();
    },
    [onTrigger, keyValue, needMeta, needShift, needCtrl, disabled],
  );

  useEventListener('keydown', handleKeyDown);
};
